module.exports = "https://static.im-cdn.com/mjc/storefront/Sakra/static/media/DefaultCategoryImage.73ea54d2.png";